import {NavItem} from '@interfaces/nav-item';


export const navItemsSuperadmin: NavItem[] = [
  {
    navCap: 'MENU',
  },
  {
    displayName: 'documents.menu',
    iconName: 'solar:document-text-line-duotone',
    route: '/documents',
  },
];
